import { render } from "./Board.vue?vue&type=template&id=d2d58250&scoped=true"
import script from "./Board.vue?vue&type=script&lang=js"
export * from "./Board.vue?vue&type=script&lang=js"

import "./Board.vue?vue&type=style&index=0&id=d2d58250&scoped=true&lang=css"

import exportComponent from "E:\\araya_2021\\tokuten\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d2d58250"]])

export default __exports__